import React from 'react';
import { connect } from 'react-redux';
import { setEmailInputToDanger, resetEmailError } from 'redux/modules/auth';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  Col,
} from 'react-bootstrap';
import LazyLoad from 'components/LazyLoad/LazyLoad';
import cocacola from 'components/LandingPage/LandingClientsSection/cocacola.png';
import disney from 'components/LandingPage/LandingClientsSection/disney.png';
import mtv from 'components/LandingPage/LandingClientsSection/mtv.png';
import muppets from 'components/LandingPage/LandingClientsSection/muppets.png';
import nokia from 'components/LandingPage/LandingClientsSection/nokia.png';
import starWars from 'components/LandingPage/LandingClientsSection/star-wars.png';
import Separator from 'components/Shared/Separator/Separator';
import EmailInput from 'components/SignUp/EmailInput';
import GoogleButton from '../PostSelectRole/GoogleButton';
import ContinueButton from '../PostSelectRole/ContinueButton';
import styles from './PostSignUp.module.scss';

const PostSignUp = ({
  email,
  emailError,
  errorState,
  loadingState,
  onChangePassword,
  onChangeEmail,
  password,
  passwordError,
  signedIn,
  googleOAuthRedirect,
  handleNext,
}) => {
  const [hasTriedToContinue, setHasTriedToContinue] = React.useState(false);

  const resetHasTriedToContinue = () => {
    setHasTriedToContinue(false);
  };

  const handleEmailChange = (email) => {
    onChangeEmail(email);
    resetHasTriedToContinue();
  };

  const handleContinueClick = () => {
    if (false && !hasTriedToContinue) {
      setHasTriedToContinue(true);
      setEmailInputToDanger();
    } else {
      handleNext();
    }
  };

  return (
    <div className={`${styles.PostSignUpContainer} turnips`}>
      {!signedIn && (
        <div className={styles.animate}>
          <TransitionGroup>
            <CSSTransition
              classNames="example"
              appear
              timeout={{ enter: 500 }}
              enter={false}
              exit={false}
            >
              <div id="post-signup-form" className={styles.signupForm}>
                <div>
                  <p className="mb fs-15 lato-bold">Sign up for free:</p>
                </div>
                <div className={`bg-grey ${styles.helpInfo}`}>
                  <p>
                    You need to sign up to Twine to contact freelancers. Your
                    email will not be shared.
                  </p>
                  <p>
                    Already registered?{' '}
                    <a
                      // check this works for specificFree and role selected
                      href={`/signin?referer=${__CLIENT__ ? '/post' : ''}`}
                      title="Sign in"
                      onClick={() => {
                        window.onbeforeunload = null;
                      }}
                    >
                      Sign in
                    </a>
                  </p>
                </div>
                <FormGroup key={1} controlId="post-brief-email">
                  <ControlLabel
                    className={styles.label}
                    style={{ margin: '1em auto 5px auto', display: 'block' }}
                  >
                    Email address:
                  </ControlLabel>
                  <EmailInput
                    type="email"
                    styles={styles}
                    disabled={loadingState}
                    value={email}
                    className={styles.input}
                    placeholder="Eg: name@company.com"
                    resetContinue={resetHasTriedToContinue}
                    onChange={(event) => onChangeEmail(event.target.value)}
                    isInPost
                  />
                  {errorState && emailError && (
                    <HelpBlock className={styles.helpBlock}>
                      {emailError}
                    </HelpBlock>
                  )}
                </FormGroup>
                <FormGroup key={2} controlId="post-brief-password">
                  <ControlLabel
                    className={styles.label}
                    style={{ margin: '0 auto 5px  auto', display: 'block' }}
                  >
                    Choose a password:
                  </ControlLabel>
                  <FormControl
                    type="password"
                    disabled={loadingState}
                    value={password}
                    className={styles.input}
                    onChange={(event) => onChangePassword(event.target.value)}
                  />
                  {errorState && passwordError && (
                    <HelpBlock className={styles.helpBlock}>
                      {passwordError}
                    </HelpBlock>
                  )}
                </FormGroup>
                <ContinueButton handleNext={handleContinueClick} />
                <Separator text="OR" />
                <GoogleButton
                  googleOAuthRedirect={googleOAuthRedirect}
                  redirect="post"
                />
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
      )}
      <Col
        className={`${styles.trustSection} ${styles.trustBorder} hidden-xs hidden-sm`}
        xs={12}
        md={6}
        mdPush={1}
      >
        <p className="aside-text fs-15">Our freelancers are trusted by:</p>
        <Col xs={6}>
          <LazyLoad>
            <img src={cocacola} alt="Coca Cola" className="relative" />
          </LazyLoad>
        </Col>
        <Col xs={6}>
          <LazyLoad>
            <img src={disney} alt="Disney" className="relative" />
          </LazyLoad>
        </Col>
        <Col xs={6}>
          <LazyLoad>
            <img src={mtv} alt="MTV" className="relative" />
          </LazyLoad>
        </Col>
        <Col xs={6}>
          <LazyLoad>
            <img src={muppets} alt="Muppets" className="relative" />
          </LazyLoad>
        </Col>
        <Col xs={6}>
          <LazyLoad>
            <img src={nokia} alt="Nokia" className="relative" />
          </LazyLoad>
        </Col>
        <Col xs={6}>
          <LazyLoad>
            <img src={starWars} alt="Star wars" />
          </LazyLoad>
        </Col>
      </Col>
    </div>
  );
};

export default connect(
  (state) => ({
    emailValidationType: state.auth.emailValidationType,
  }),
  { setEmailInputToDanger, resetEmailError }
)(PostSignUp);
